import React, { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { isIOSNative } from '@xunlei/universal-native-api'
import AndroidBriage from '@/utils/bridge/android-briage'
import { getUserInfo } from '@/utils/bridge'
import { $store } from '@/store'
import { IUserInfo } from 'types/user'

type IUser = IUserInfo
export interface AuthContextType {
    isAuthenticated: boolean
    user: IUser|null
    signin: (user: IUser, callback?: VoidFunction) => void
    signout: (callback?: VoidFunction) => void
    updateUser: (user: IUser) => void
}

export const authProviderValues = {
    user: {},
    isAuthenticated: false,
    signin(user: IUser, callback?: VoidFunction) {
        authProviderValues.user = user
        authProviderValues.isAuthenticated = !!user?.access_token
        callback && setTimeout(callback, 100)
    },
    signout(callback?: VoidFunction) {
        authProviderValues.isAuthenticated = false
        authProviderValues.user = {}
        callback && setTimeout(callback, 100)
    },
}

export function AuthProvider({ children }: { children: React.ReactNode }) {
    const navigate = useNavigate()
    const [user, setUser] = React.useState<IUser | null>(null)
    const [isAuthenticated, updateAuthenticated] = React.useState<boolean>(true)

    const signin = (user: IUser, callback?: VoidFunction) => {
        return authProviderValues.signin(user, () => {
            updateAuthenticated(!!user?.access_token)
            setUser(user)
            callback && callback()
            $store.user = user
        })
    }

    const signout = (callback?: VoidFunction) => {
        return authProviderValues.signout(() => {
            // logout()
            updateAuthenticated(false)
            setUser(null)
            navigate('/login')
            $store.user = null!
            $store.deviceId = ''
            $store.cookie = ''
            // $store.dispatch(setLogout())
            if (typeof callback === 'function') callback()
        })
    }

    const updateUser = (user: IUser) => {
        setUser(user)
        // updateCacheUserInfo(user)
        $store.user = user
    }

    useEffect(() => {
        if (isIOSNative || AndroidBriage.isAndroidNative) {
            getUserInfo().then(signin)
        }
        // auth.getlogInfo().then(signin)
        // addEventListener('tokenExpired', signout)
    }, [])

    const value = { user, signin, signout, updateUser, isAuthenticated }

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}

export const AuthContext = React.createContext<AuthContextType>(null!)

export function useAuth() {
    return React.useContext(AuthContext)
}